import { createFileRoute, Outlet } from '@tanstack/react-router'

/**
 * Settings · Integrations — a platform section with four children
 * (docs/integrations-requirements.md D1; docs/settings.md §Integrations):
 *
 *   Catalog      the integration types the platform can read from and act on
 *   Instances    the tenant's configured instances, with their last test
 *   Governance   roles, risk policy, approval settings
 *   Plugins      the platform plugin store (the page that WAS this section)
 *
 * The first three are served by the SynthAI backend today, so their shims
 * sit behind `ProductGate synthai`; Plugins is the datafabric's and renders
 * without it. The nav children come from the SynthAI manifest's `platform`
 * section, merged into the core Integrations item by core-shell
 * (`settingsGroupsFor`), so the item keeps its place and gate whatever the
 * entitlement — unentitled, it is simply the plugin store again.
 */
function IntegrationsLayout() {
  return <Outlet />
}

export const Route = createFileRoute('/$clusterId/$scopeId/settings/integrations')({
  component: IntegrationsLayout,
})
